import TextField, { TextFieldProps } from '@mui/material/TextField';
import React from 'react';

export interface CustomTextFieldProps extends Omit<
  TextFieldProps,
  'helperText'
> {
  helperText?: string;
}

const CustomTextField = React.forwardRef<HTMLDivElement, CustomTextFieldProps>(
  ({ variant = 'outlined', ...props }, ref) => {
    return <TextField ref={ref} variant={variant} {...props} />;
  }
);

CustomTextField.displayName = 'CustomTextField';

export default CustomTextField;
